module.exports = __webpack_public_path__ + "img/playa_privada.9a7be5f5.svg";